import React, { useState, useMemo, useRef, useEffect } from "react";
import { Button, Input, Space, Typography, Drawer, Form, Select } from "antd";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { ConverterConfigGrid } from "../../../../../../Common/UIConstants";
import DashMeters from "../DashMeters/DashMeters";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";

const { Search } = Input

const DashConverters = () => {
  const [drawerOpen, setDrawerOpen2] = useState(false);
  const [form] = Form.useForm();
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [rowData, setRowData] = useState([]);
  const mode = useSelector((state) => state.darkMode);
  const [isloading, setISLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);
  const { isdarkMode } = mode;
  const [selectedMeterID, setSelectedMeterID] = useState(null);
  const color = useSelector((state) => state.ThemeChange);
  console.log(color);
  const [modules, setModules] = useState([]);
  const [filteredData, setFilteredData] = useState(rowData);

const handleSearch = (value) => {
    const fullQuery = value.trim().toLowerCase();      // full string
    const queryChars = fullQuery.split(''); 
    console.log(fullQuery)           
    console.log(queryChars)           

    const result = rowData.filter((item) =>
      Object.values(item).some((field) => {
        const fieldStr = String(field ?? '').toLowerCase();
        console.log(fieldStr)
        return (
          fieldStr.includes(fullQuery) 
          // ||                      // match full string
          // queryChars.some((char) => fieldStr.includes(char))   // OR match any char
        );
      })
    );
    console.log(result)

    setFilteredData(result);
  };

  useEffect(() => {
    setTimeout(() => {
      setISLoading(false);
    }, 2000);
  },[]);
  useEffect(() => {
      const savedValue = localStorage.setItem("selectedSiteID", selectedMeterID);
      console.log(savedValue);
  },[selectedMeterID]);

  const handleNotification = (msg) => {
    notification.open({
      message: msg,
      type: msg.includes("successfully") ? "success" : "error",
      placement: "topRight",
      duration: 3,
    });
  };

  const getReponse = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    })
      .then((res) => {
        console.log("Converter:", res);
        if (res && res.length) {
          setRowData(res); 
          setFilteredData(res)
        }
      })
      .catch((err) => {
        handleNotification("Error fetching data");
      });
  };

  const refetchData = () => {
    getReponse();
  };

  useEffect(() => {
    getReponse();
  }, [refetch]);

  const handleDeleteSubmit = (siteID) => {
    try {
      makeRequest({
        type: APIConstants.DELETE,
        url: `${APIConstants.DELETE_CONFIG_CONVERTER}?SITEID=${siteID}&IsDelete=true`,
      })
        .then((res) => {
          if (res) {
            const updatedRowData = rowData.filter(
              (item) => item.siteID !== siteID
            );
            setRowData(updatedRowData);
            setRefetch(!refetch);

            handleNotification("Converter successfully deleted!");
          }
        })
        .catch((error) => {
          console.error(error);
          handleNotification("An error occurred while deleting the converter.");
        });
    } catch (err) {
      console.error(err);
      handleNotification(
        "An unexpected error occurred while deleting the converter."
      );
    }
  };

  const openDrawer = () => setDrawerOpen2(true);
  const closeDrawer = () => setDrawerOpen2(false);

  const onFinish = (values) => {
    console.log("Form submitted:", values);
    insertGroup(values);
    form.resetFields();
    closeDrawer();
  };

  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`,
    }).then((res) => {
      if (res && res.length) {
        setModules(res);
      }
      console.log("Get Modules :", res);
    });
  };

  useEffect(() => {
    getModules();
  }, []);

  const insertGroup = (formValues) => {
    console.log(formValues);
    const body = {
      converterID: formValues.converterID,
      converterName: formValues.converterName,
      converterIP: formValues.converterIP,
      port: formValues.port,
      noofports: formValues.noofports,
      moduleType: formValues.converterType.toString(),
    };
    console.log(body);
    const url = `${APIConstants.CONFIG_INSERT_CONVERTER}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    })
      .then((res) => {
        console.log(res);
        if (res && res.message) {
          // handleNotification("Converter successfully saved!", "success");
          handleNotification(res.message, "success");
          setRefetch(!refetch);
        }
        // if (res ) {
        //   handleNotification("Converter successfully saved!", "success");
        //   // handleNotification(res.message,"success");
        //   setRefetch(!refetch)
        // }
      })
      .catch((err) => {
        console.error(err);
        handleNotification(
          "An error occurred while saving the converter.",
          "error"
        );
      });
  };

//   const converterExcel = (data) => {
//     if(data.length === 0) {
//       handleNotification("No data available to export", "warning");
//     }
    
//   const formattedData = data.map((item, index) => ({
//     "S. No.": index + 1,
//     "Converter Name": item.siteName,
//     "Converter ID": item.siteID,
//     "IP Address": item.siteIP ?? "",
//     "Port": item.port,
//     "No. of Ports": item.noofPorts,
//     "Electrical": item.isElectrical,
//     "Temperature": item.isTemperature,
//     "Air": item.isAir,
//     "Steam": item.isSteam,
//     "Water": item.isWater,
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(formattedData);
//   const workbook = XLSX.utils.book_new();

//   XLSX.utils.book_append_sheet(workbook, worksheet, "Converters");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const fileData = new Blob([excelBuffer], {
//     type: "application/octet-stream",
//   });

//   saveAs(fileData, "Converters.xlsx");
// };
  console.log(isdarkMode);


// Helper to fetch image as ArrayBuffer
const getImageBufferFromUrl = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const arrayBuffer = await response.arrayBuffer();
  return arrayBuffer;
};

//  const converterExcel = async (data) => {
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet('Converters');

//   //  Merge A1:J4 (first 4 rows, 10 columns)
//   worksheet.mergeCells('A1:K5');

//   //  Add dummy image
//   const imageUrl = minnotra_logo;
//   const imageBuffer = await getImageBufferFromUrl(imageUrl);

//   const imageId = workbook.addImage({
//     buffer: imageBuffer,
//     extension: 'png',
//   });

//   //  Add image in merged cell (adjusted to fit the merged area)
//   worksheet.addImage(imageId, {
//     tl: { col: 1.5, row: 0.2 },     // Top-left anchor
//     ext: { width: 400, height: 90 }, // Image size
//   });

//   //  Header row will be at row 6 (since 1-4 are for image, and leave row 5 empty)
//   const headerRowIndex = 6;

//   const headers = [
//     "S. No.",
//     "Converter Name",
//     "Converter ID",
//     "IP Address",
//     "Port",
//     "No. of Ports",
//     "Electrical",
//     "Temperature",
//     "Air",
//     "Steam",
//     "Water",
//   ];

//   worksheet.insertRow(headerRowIndex, headers);

//   const headerRow = worksheet.getRow(headerRowIndex);
//   headerRow.eachCell((cell) => {
//     cell.fill = {
//       type: 'pattern',
//       pattern: 'solid',
//       fgColor: { argb: 'FFFF0000' }, // Red background
//     };
//     cell.font = {
//       color: { argb: 'FFFFFFFF' }, // White text
//       bold: true,
//     };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });

//   //  Add data starting from row 7
//   data.forEach((item, index) => {
//     worksheet.addRow([
//       index + 1,
//       item.siteName,
//       item.siteID,
//       item.siteIP ?? "",
//       item.port,
//       item.noofPorts,
//       item.isElectrical,
//       item.isTemperature,
//       item.isAir,
//       item.isSteam,
//       item.isWater,
//     ]);
//   });

//   //  Save file
//   const buffer = await workbook.xlsx.writeBuffer();
//   saveAs(new Blob([buffer]), 'Converters.xlsx');
// };
  
const converterExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Converters');

  // Step 1: Merge cells A1:B2 for the logo area
  worksheet.mergeCells('A1:B2');

  // Step 2: Add logo with smaller size
  const imageUrl = minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(imageUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: 'png',
  });

  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.1 },
    ext: { width: 100, height: 25 },
  });

  // Step 3: Header row now at row 3 (moved up)
  const headerRowIndex = 3;
  const headers = [
    "S. No.",
    "Converter Name",
    "Converter ID",
    "IP Address",
    "Port",
    "No. of Ports",
    "Electrical",
    "Temperature",
    "Air",
    "Steam",
    "Water",
  ];
  worksheet.insertRow(headerRowIndex, headers);

  // Step 4: Style header row (green background, white text, border)
  const headerRow = worksheet.getRow(headerRowIndex);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B050' }, // Green
    };
    cell.font = {
      bold: true,
      color: { argb: 'FFFFFFFF' }, // White
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Step 5: Add data rows starting from row 4
  const dataStartRow = headerRowIndex + 1;
  data.forEach((item, index) => {
    const row = worksheet.addRow([
      index + 1,
      item.siteName,
      item.siteID,
      item.siteIP ?? "",
      item.port,
      item.noofPorts,
      item.isElectrical,
      item.isTemperature,
      item.isAir,
      item.isSteam,
      item.isWater,
    ]);

    // Add borders to each data cell
    row.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  });

  // Step 6: Save file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'Converters.xlsx');
};

console.log(selectedMeterID)
console.log(filteredData)
  return (
    <div className="p-4 rounded-xl shadow-md h-screen">
      <div className="mb-5">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
        <span
          level={4}
          className={` ${isdarkMode ? "text-white" : "text-black "}  text-xl  !mb-0`}
        >
          Converters
          {/* <span className="text-blue-500 text-sm">(240 Converters)</span> */}
        </span>
        <Space>
          {/* <Input.Search placeholder="Search" allowClear />
           */}
           <Search
        placeholder="Search"
        allowClear
        onSearch={handleSearch}
        style={{ width: 300 }}
      />
          <Button disabled={rowData.length==0} onClick={()=>converterExcel(rowData)} icon={<FileExcelOutlined />}>Export Excel</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={openDrawer}>
            Add Converter
          </Button>
        </Space>
      </div>

      <ConverterConfigGrid
      selectedMeterID={selectedMeterID}
      setSelectedMeterID={setSelectedMeterID}
        data={filteredData}
        handleDeleteSubmit={handleDeleteSubmit}
        refetch={refetch}
        setRefetch={setRefetch}
      />

      {/* Right Drawer for Form */}
      <Drawer
        title="Add Converter Details"
        placement="right"
        onClose={closeDrawer}
        open={drawerOpen}
        width={500}
        footer={
          <div className="flex justify-between px-4 py-2">
            <Button onClick={closeDrawer}>Cancel</Button>
            <Button type="primary" onClick={() => form.submit()}>
              Save
            </Button>
          </div>
        }
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            name="converterID"
            label="Converter ID"
            rules={[{ required: true, message: "Enter converter ID" }]}
          >
            <Input placeholder="Enter converter ID" />
          </Form.Item>

          <Form.Item
            name="converterName"
            label="Converter Name"
            rules={[{ required: true, message: "Enter converter name" }]}
          >
            <Input placeholder="Enter converter name" />
          </Form.Item>

          <Form.Item
            name="converterIP"
            label="Converter IP"
            rules={[{ required: true, message: "Enter IP address" }]}
          >
            <Input placeholder="Enter converter IP" />
          </Form.Item>

          <Form.Item
            name="port"
            label="Port"
            rules={[{ required: true, message: "Enter port number" }]}
          >
            <Input placeholder="Enter port" />
          </Form.Item>

          <Form.Item
            name="noofPorts"
            label="No. of Ports"
            rules={[{ required: true, message: "Enter number of ports" }]}
          >
            <Input placeholder="Enter no of ports" type="number" />
          </Form.Item>

          <Form.Item
            name="converterType"
            label="Converter Type"
            rules={[{ required: true, message: "Select converter type" }]}
          >
            <Select placeholder="Select converter type">
              {modules.map((item) => (
                <Select.Option
                  mode="multiple"
                  key={item.moduleId}
                  value={item.moduleName}
                >
                  {item.moduleName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Drawer>

      </div>
      <div className="">
        <DashMeters selectedSiteID={selectedMeterID} />
      </div>
    </div>
  );
};

export default DashConverters;
